/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Stats_Pending_InvitesInputs */



/**
* | output |
* | --- |
* | "Pending Invites" |
*
* @param {Members_Stats_Pending_InvitesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_stats_pending_invites = /** @type {((inputs?: Members_Stats_Pending_InvitesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Stats_Pending_InvitesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausstehende Einladungen")
	return /** @type {LocalizedString} */ ("Pending Invites")
});